// extracted by mini-css-extract-plugin
export default {"column":"Column_column__YYoUp","h2":"Column_h2__1izzj"};